import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import NewsStore from './store';
import Link from '@src/components/link';
import SimpleSwiper from '@src/components/swiper/simple-swiper';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const getHotTopNewsChannels = channelInfo =>
  Object.keys(channelInfo)
    .map(key => key.match(/^url_(\d+)_name$/))
    .filter(Boolean)
    .map(match => ({
      index: Number(match[1]),
      name: channelInfo[match[0]],
      urlKey: `url_${match[1]}`
    }))
    .filter(item => String(item.name || '').trim() && String(channelInfo[item.urlKey] || '').trim())
    .sort((a, b) => a.index - b.index);

const News = ({ store }) => {
  store.use();
  const hotTopNewsChannels = getHotTopNewsChannels(store.newChennelInfo);

  return (
    <div className={styles.news}>
      <div className={styles.content}>
        <div className={styles.newImg}>
          <div className={styles.newImgTitle} />
          <div className={styles.newSwiper}>
            <div className={styles.newSwiperWrap}>
              <SimpleSwiper params={store.params} key={store.newsImgList.length}>
                {store.newsImgList.map((item, index) => (
                  <Link className={styles.newSwiperItem} key={index}>
                    <img src={item.url} alt="" />
                  </Link>
                ))}
              </SimpleSwiper>
              <Link className={cx(styles.swiperBtn, styles.swiperBtnPrev)} onClick={() => store.changeSwiper('prev')} />
              <Link className={cx(styles.swiperBtn, styles.swiperBtnNext)} onClick={() => store.changeSwiper('next')} />
            </div>
          </div>
          <div className={styles.newSwiperSlide}>
            {store.newsImgList.map((item, index) => (
              <Link
                className={cx(styles.newSwiperSlideItem, store.currentIndex === index && styles.active)}
                key={index}
                onClick={() => {
                  store.changeSwiper(index);
                }}
              />
            ))}
          </div>
        </div>
        <div className={styles.newInfo}>
          <div className={styles.newHead}>
            <div className={styles.newTabs}>
              {store.newTabList.map((item, index) => (
                <Link
                  className={cx(styles.newTabItem, styles[`newTabItem${index}`], store.currentTab === index && styles.active)}
                  key={index}
                  onClick={() => {
                    store.changeTab(index, item);
                  }}
                >
                  {/* {item.title} */}
                  <span />
                </Link>
              ))}
            </div>
            <Link
              className={styles.newMore}
              onClick={() => {
                $$tracker.clickJhkbMore();
                store.gotoNewsList();
              }}
            />
          </div>
          <div className={styles.line} />

          <div className={styles.hotTopNews}>
            <Link
              className={styles.hotTopNewsTitle}
              onClick={() => {
                $$tracker.clickJhkbNews(store.topData.title || '');
                store.gotoDetail(store.topData);
              }}
            >
              {store.topData.title || ''}
            </Link>
            <div className={styles.hotTopNewsChannel}>
              {hotTopNewsChannels.map(item => (
                <Link key={item.urlKey} onClick={() => store.openNewTab(item.urlKey)}>
                  [{item.name}]
                </Link>
              ))}
            </div>
          </div>

          <div className={styles.newsList}>
            {store.newList.length > 0 &&
              store.newList.slice(0, 4).map((item, index) => (
                <div
                  className={cx(styles.newsListItem)}
                  key={index}
                  onClick={() => {
                    $$tracker.clickJhkbNews(item.title);
                    store.gotoDetail(item);
                  }}
                >
                  <div className={cx(styles.newsListItemType)}>{item.categoryName}</div>
                  <Link className={styles.newsListItemTitle}>{item.title}</Link>
                  <div className={styles.newsListItemDate}>{item.date}</div>
                </div>
              ))}
            {store.newList.length === 0 && <div className={styles.noData}>暂无内容</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(News, NewsStore);
